import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    paramsLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  };
};
